/**
 * ============================================================================
 * MARK AS DELIVERED PAGE - 100% Ready
 * ============================================================================
 * 
 * Seller Marks as Delivered
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UserDashboardLayout } from '../components/user';
import MarkDelivered from '../components/delivery/MarkDelivered';
import Button from '../components/common/Button';
import { useI18n } from '../providers';

/**
 * Mark Delivered Page
 * @returns {JSX.Element}
 */
const MarkDeliveredPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { language } = useI18n();

  const handleSuccess = () => {
    navigate(`/transactions/${id}`);
  };

  return (
    <UserDashboardLayout>
      {/* Header */}
      <div className="mb-8 animate-fadeInUp">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(`/transactions/${id}`)}
          className="mb-4"
        >
          ← {language === 'fr' ? 'Retour à la transaction' : 'Back to Transaction'}
        </Button>
        <h1 className="text-4xl font-black bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent mb-2">
          ✅ {language === 'fr' ? 'Marquer comme livré' : 'Mark as Delivered'}
        </h1>
        <p className="text-gray-600 dark:text-gray-400 text-lg">
          {language === 'fr'
            ? 'Téléchargez vos livrables et marquez la transaction comme livrée'
            : 'Upload your deliverables and mark the transaction as delivered'}
        </p>
      </div>

      {/* Mark Delivered Component */}
      <div className="animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
        <MarkDelivered transactionId={id} onSuccess={handleSuccess} />
      </div>
    </UserDashboardLayout>
  );
};

export default MarkDeliveredPage;
